import { cn } from '@/utils/helpers';

export type AssetIconProps = {
  src: string;
  alt?: string;
  size?: number;
  width?: number;
  height?: number;
  className?: string;
};

/** Renders a bundled SVG/PNG from `src/assets/icons`. */
export function AssetIcon({
  src,
  alt = '',
  size,
  width,
  height,
  className,
}: AssetIconProps) {
  const w = width ?? size ?? 20;
  const h = height ?? size ?? 20;

  return (
    <img
      src={src}
      alt={alt}
      width={w}
      height={h}
      className={cn('asset-icon', 'block', className)}
      aria-hidden={!alt}
      draggable={false}
    />
  );
}
